import qs from 'qs';

import ApiService from 'services/ApiService/ApiService';
import ConfigurationService, { ConfigurationKeys } from 'services/ConfigurationService';
import getMessagingServiceInstance, { MessagingService } from 'services/MessagingService/MessagingService';
import {
  GET_AWARDS_DAILY_WINNERS,
  GET_AWARDS_DAILY_WINNERS_ERROR,
  GET_AWARDS_DAILY_WINNERS_RESPONSE,
  GET_AWARDS_MONTHLY_WINNERS,
  GET_AWARDS_MONTHLY_WINNERS_ERROR,
  GET_AWARDS_MONTHLY_WINNERS_RESPONSE,
  GET_AWARDS_RESPONSE,
} from 'services/MessagingService/EventNames';
import parseCatch from 'utils/parseCatch';
import { User } from 'stores/UserStore/UserStore.types';


const BASE_URL = ConfigurationService.get(ConfigurationKeys.BASE_URL);

const ROOT_AWARDS_URL = `${BASE_URL}/rest/v1.0/awards`;
const GET_DAILY_WINNERS_URL = `${ROOT_AWARDS_URL}/day`;
const GET_MONTHLY_WINNERS_URL = `${ROOT_AWARDS_URL}/month`;
const PROFILE_AWARDS_URL = `${ROOT_AWARDS_URL}/{username}`;

/**
 * @class handles business logic for awards and expose methods
 */
class AwardService {

  constructor(public messagingService: MessagingService) {
    this.messagingService.on(GET_AWARDS_DAILY_WINNERS, this.getDailyWinners);
    this.messagingService.on(GET_AWARDS_MONTHLY_WINNERS, this.getMonthlyWinners);
  }

  /**
   * @param dateTime format: 2020-07-29 (YYYY-DD-MM)
   */
  getDailyWinners = (dateTime: string = null): void => {
    const query = { ...(dateTime && { dateTime }) };
    const URL = encodeURI(`${GET_DAILY_WINNERS_URL}${qs.stringify(query, { addQueryPrefix: true })}`);
    ApiService.get(URL)
      .then((response) => {
        this.messagingService.emit(GET_AWARDS_DAILY_WINNERS_RESPONSE, response.data);
      })
      .catch((error) => {
        this.messagingService.emit(GET_AWARDS_DAILY_WINNERS_ERROR, error);
      });
  };

  /**
   * @param dateTime format: 2020-07-29 (YYYY-DD-MM)
   */
  getMonthlyWinners = (dateTime: string = null): void => {
    const query = { ...(dateTime && { dateTime }) };
    const URL = encodeURI(`${GET_MONTHLY_WINNERS_URL}${qs.stringify(query, { addQueryPrefix: true })}`);
    ApiService.get(URL)
      .then((response) => {
        this.messagingService.emit(GET_AWARDS_MONTHLY_WINNERS_RESPONSE, response.data);
      })
      .catch((error) => {
        this.messagingService.emit(GET_AWARDS_MONTHLY_WINNERS_ERROR, error);
      });
  };

  getAwards = (performerName: User['username']): void => {
    const URL = PROFILE_AWARDS_URL.replace('{username}', encodeURIComponent(performerName));
    ApiService.get(URL)
      .then((res) => this.messagingService.emit(GET_AWARDS_RESPONSE, res.data))
      .catch((err) => parseCatch(err));
  };
}

export default new AwardService(getMessagingServiceInstance());
